import { FeedbackOfferNotice } from "../customNotice/botNotice/feedbackOfferNotice";
import { TrackingNotice } from "../customNotice/botNotice/trackingNotice";
import { ScreenChangeNotice } from "../customNotice/clientNotice/screenChangeNotice";
export class WidgetHeaderController {
    constructor(widget) {
        this.minimizeDisabled = false;
        this.closeDisabled = false;
        this.endChatOnCloseButton = false;
        this.chatEnded = false;
        this.elements = {};
        this.elements['minimizeIcon'] = $('.js-minimize-chat');
        this.elements['closeIcon'] = $('.js-chat-close-modal');
        this.elements['downloadIcon'] = $('.js-download-modal');
        this.elements['modal'] = $('#closeWindow');
        this.elements['closeCloseChatModal'] = $('.js-popup-close');
        this.elements['closeChatAcceptButton'] = $('.js-chat-close-accept');
        this.widget = widget;
        this.registerEventHandlers();
    }
    registerEventHandlers() {
        // das ist der Klick aufs X rechts oben im Widget
        this.elements['closeIcon'].on('click', () => {
            this.handleChatCloseButtonAction();
        });
        this.elements['closeCloseChatModal'].on('click', () => {
            this.widget.track("chat", "buttonclick", "close_no");
            this.toggleCloseChatModal();
        });
        this.elements['closeChatAcceptButton'].on('click', () => {
            this.handleChatCloseAcceptedButtonAction();
            this.toggleCloseChatModal();
        });
    }
    toggleCloseChatModal() {
        this.elements['modal'].css('cbot-popup--visible');
        this.elements['modal'].toggleClass('cbot-popup--visible');
    }
    handleChatCloseButtonAction() {
        this.widget.track("chat", "close", this.widget.getStateMachine().screen + "_screen");
        if (!this.widget.activeChatSession()) {
            this.widget.uic.close();
        }
        else if (this.endChatOnCloseButton) {
            this.endChat();
        }
        else if (this.chatEnded) {
            this.widget.uic.close();
        }
        else {
            this.toggleCloseChatModal();
        }
    }
    handleChatCloseAcceptedButtonAction() {
        this.widget.track("chat", "buttonclick", "close_yes");
        if (this.widget.state.feedbackOfferLocal &&
            this.widget.state.feedbackOfferGlobal &&
            this.widget.state.botConnected) {
            // send feedbackOffer
            this.widget.state.feedbackOfferGlobal = false;
            this.widget.uic.showScreen("feedback");
            this.widget.sendCustomNotice(new TrackingNotice("chat", "Feedback_screen_view", "Feedback_screen_view"));
            this.widget.sendCustomNotice(new ScreenChangeNotice("feedback", this.widget.getWidgetApplicationId()));
            this.widget.sendCustomNotice(new FeedbackOfferNotice(false));
        }
        else {
            this.endChat();
        }
    }
    endChat() {
        this.widget.track("chat", "chat_ended", "closed");
        this.chatEnded = true;
        this.widget.endChatSession(this.widget.sendCustomNotice(new TrackingNotice("chat", "Chat_end_closed", "Chat_end_closed")));
    }
    enableEndChatOnCloseButton() {
        this.endChatOnCloseButton = true;
    }
    disableEndChatOnCloseButton() {
        this.endChatOnCloseButton = false;
    }
    disableMinimizeIcon() {
        this.minimizeDisabled = true;
        this.hideMinimizeIcon();
    }
    disableCloseIcon() {
        this.closeDisabled = true;
        this.hideCloseIcon();
    }
    showIcons() {
        this.showMinimizeIcon();
        this.showCloseIcon();
        this.showDownloadIcon();
    }
    hideCloseIcon() {
        this.elements['closeIcon'].hide();
    }
    showCloseIcon() {
        if (this.closeDisabled) {
            this.hideCloseIcon();
        }
        else {
            this.elements['closeIcon'].show();
        }
    }
    hideDownloadIcon() {
        this.elements['downloadIcon'].hide();
    }
    showDownloadIcon() {
        this.elements['downloadIcon'].show();
    }
    hideMinimizeIcon() {
        this.elements['minimizeIcon'].hide();
    }
    showMinimizeIcon() {
        if (this.minimizeDisabled) {
            this.hideMinimizeIcon();
        }
        else {
            this.elements['minimizeIcon'].show();
        }
    }
    reset() {
        this.endChatOnCloseButton = false;
        this.chatEnded = false;
    }
}
